import {
  getCategory,
  getColorForCategory,
  getFeaturedPostsForCategory,
  getRecentCategoryPosts,
  getStickyPostIDsForCategory,
  getStickyPostsForCategory,
  getTags,
  POST_COUNT,
  setPostCount,
} from "lib/api";
import { pageCategories } from "lib/constants";
import { SupportedLanguage } from "lib/lexemes/supported-languages";
import { getLocale } from "lib/localization";
import { GetStaticPropsContext } from "next";
import type { Props } from "./category-page-next";

export function getStaticPropsGetter(category: Props["category"]) {
  const getStaticProps = async function getStaticProps({
    params,
  }: GetStaticPropsContext<{ lang: SupportedLanguage }>) {
    const lang = getLocale(undefined, params);

    const [stickyPostIds] = await Promise.all([
      getStickyPostIDsForCategory(pageCategories[category].id),
    ]);

    // @todo - Pass lang to posts and categories
    const [
      { subTitle, splashPost, featuredPosts },
      recentPosts,
      { color },
      { stickyPosts },
      { title, description, imageSrc },
      { tags },
    ] = await Promise.all([
      getFeaturedPostsForCategory(pageCategories[category].category),
      getRecentCategoryPosts({
        categoryName: pageCategories[category].category,
        count: POST_COUNT,
        notIn: stickyPostIds.length ? stickyPostIds : undefined,
      }),
      getColorForCategory(pageCategories[category].id),
      getStickyPostsForCategory(pageCategories[category].id),
      getCategory(pageCategories[category].id),
      getTags(),
    ]);

    const categoryName = pageCategories[category].category;

    return {
      props: {
        category,
        lang,
        subTitle,
        splashPost,
        featuredPosts,
        recentPosts,
        recentPostsTotal: setPostCount(recentPosts.total),
        stickyPosts,
        color,
        pageType: "Category",
        title,
        description,
        imageSrc,
        categoryName,
        tags,
      },
      // Check for updates every 20 seconds
      revalidate: 20,
    };
  };

  return getStaticProps;
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}
